import React from 'react';
import { connect } from 'react-redux';
import { fetchAdministrationFraisRetourExclus } from 'store/administration/administrationActions';
import { getPctJokerFraisRetour } from 'store/administration/administrationActions';
import { patchPctJokerFraisRetour } from 'store/administration/administrationActions';
import { postFraisRetourExclu } from 'store/administration/administrationActions';
import { deleteFraisRetourExclu } from 'store/administration/administrationActions';
import AdministrationFraisRetourExclus from './AdministrationFraisRetourExclus';
import withLoader from 'components/Shared/withLoader';

const AdministrationFraisRetourExclusWithLoader = withLoader(AdministrationFraisRetourExclus);

class AdministrationFraisRetourExclusContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            addFraisRetourExcluDialogOpen: false,
            deleteFraisRetourExcluDialogOpen: false,
            fraisRetourExcluToDelete: null,
            pctJokerFraisRetour: 0
        };
    }

    async componentDidMount() {
        await this.props.fetchAdministrationFraisRetourExclus();
        const response = await this.props.getPctJokerFraisRetour();
        this.handlePctJokerFraisRetourChange(response);
    }

    handleOpenAddDialog = () => {
        this.setState({
            addFraisRetourExcluDialogOpen: true
        });
    };

    handlePctJokerFraisRetourChange = (value) => {
        this.setState({
            ...this.state, pctJokerFraisRetour: value
        });
    }

    patchPctJokerFraisRetour = async () => {
        const { pctJokerFraisRetour } = this.state;

        await this.props.patchPctJokerFraisRetour(pctJokerFraisRetour);
    }

    handleCloseAddDialog = () => {
        this.setState({
            addFraisRetourExcluDialogOpen: false
        });
    };

    addFraisRetourExclu = async (fraisRetourExclu) => {
        await this.props.postFraisRetourExclu(fraisRetourExclu);
    };

    handleOpenDeleteDialog = (fraisRetourExcluId) => {
        this.setState({
            deleteFraisRetourExcluDialogOpen: true,
            fraisRetourExcluToDelete: this.props.fraisRetourExclus.find(x => x.id === fraisRetourExcluId)
        });
    };

    handleCloseDeleteDialog = () => {
        this.setState({
            deleteFraisRetourExcluDialogOpen: false,
            fraisRetourExcluToDelete: null
        });
    };

    deleteFraisRetourExclu = async (fraisRetourExcluId) => {
        this.setState({
            deleteFraisRetourExcluDialogOpen: false
        });
        await this.props.deleteFraisRetourExclu(fraisRetourExcluId);
    };

    render() {
        const { isLoading, niveaux, fraisRetourExclus } = this.props;
        const { pctJokerFraisRetour } = this.state;

        return (
            <AdministrationFraisRetourExclusWithLoader
                isLoading={isLoading}
                niveaux={niveaux}
                fraisRetourExclus={fraisRetourExclus}
                pctJokerFraisRetour={pctJokerFraisRetour}

                addFraisRetourExcluDialogOpen={this.state.addFraisRetourExcluDialogOpen}
                addFraisRetourExclu={this.addFraisRetourExclu}
                onOpenAddDialog={this.handleOpenAddDialog}
                onCloseAddDialog={this.handleCloseAddDialog}

                deleteFraisRetourExcluDialogOpen={this.state.deleteFraisRetourExcluDialogOpen}
                deleteFraisRetourExclu={this.deleteFraisRetourExclu}
                onOpenDeleteDialog={this.handleOpenDeleteDialog}
                onCloseDeleteDialog={this.handleCloseDeleteDialog}
                fraisRetourExcluToDelete={this.state.fraisRetourExcluToDelete}
                onPctJokerFraisRetourChange={this.handlePctJokerFraisRetourChange}
                patchPctJokerFraisRetour={this.patchPctJokerFraisRetour}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let niveaux = state.administration.fraisRetourExclus.niveaux;
    let fraisRetourExclus = state.administration.fraisRetourExclus.items;

    // TODO frais par niveaux

    return {
        isLoading: state.administration.fraisRetourExclus.isLoading,
        niveaux: niveaux,
        fraisRetourExclus: fraisRetourExclus
    };
};

const mapDispatchToProps = {
    fetchAdministrationFraisRetourExclus,
    getPctJokerFraisRetour,
    postFraisRetourExclu,
    deleteFraisRetourExclu,
    patchPctJokerFraisRetour
};

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationFraisRetourExclusContainer);